/**
 * While editing delivery zones with manual save, ignore hub ORM patches for that store so
 * realtime events do not clobber the server baseline under the draft overlay.
 */
export const shouldSuppressDeliveryZoneHubSync = (
  state: AppState,
  eventStoreId: number | string | undefined
): boolean => {
  if (eventStoreId == null) {
    return false;
  }
  const draft = state.deliveryZones.draft;
  if (draft.storeId == null || Number(draft.storeId) !== Number(eventStoreId)) {
    return false;
  }
  return draft.dirty || draft.status === 'saving';
};
